import CargoCompanyDispatcherListRequest from "../../../../api/raily/cargo-company/dispatcher/list/cargo-company-dispatcher-list.request";
import CargoCompanyDispatcherListParams from "./cargo-company-dispatcher-list-params";

const create = (
  params: CargoCompanyDispatcherListParams,
): CargoCompanyDispatcherListRequest => {
  return {
    companyUuid: params.companyUuid,
  };
};

const cargoCompanyDispatcherListParamsFactory = {
  create,
};

export default cargoCompanyDispatcherListParamsFactory;
